import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { includedToday, bonuses, BONUS_VALUE } from '../data/content';
export function ValueStackSection() {
  return <section aria-labelledby="recibis" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-14 text-center" data-id="element-188" data-mp="1meec63kzgmgd">
      <Reveal data-id="element-189" data-mp="tne158o8iif7">
        <SectionHeading id="recibis" title="Todo lo que recibís hoy" data-id="element-190" data-mp="tmuljym2464c" />
      </Reveal>

      <div className="mx-auto mt-10 grid max-w-4xl gap-4 md:grid-cols-2" data-id="element-191" data-mp="op2tn4lewk05">
        <Reveal className="flex h-full flex-col rounded-2xl border border-line bg-surface p-7 text-left" data-id="element-192" data-mp="oqw28pfl5eas">
          <h3 className="text-center text-sm font-bold uppercase tracking-[0.2em] text-gold" data-id="element-193" data-mp="ymqqq16hq3lh">
            El Mega Pack
          </h3>
          <ul className="mt-5 space-y-3" data-id="element-194" data-mp="2e2g1v4wnas6j">
            {includedToday.map(item => <li key={item} className="flex items-start gap-2.5 text-sm md:text-base font-medium text-ink" data-id="element-195" data-mp="2a2ffmy3b1cox">
                <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-cta" strokeWidth={3} data-id="element-196" data-mp="1nf2vc02f3zft" />
                <span data-id="element-197" data-mp="1weyaefz3gel4">{item}</span>
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.05} className="flex h-full flex-col rounded-2xl border-2 border-gold-bright bg-gold-soft p-7 text-left" data-id="element-198" data-mp="21bgf5fufccxg">
          <h3 className="text-center text-sm font-bold uppercase tracking-[0.2em] text-gold" data-id="element-199" data-mp="18nsw458sxucx">
            Y además, 5 bonos gratis
          </h3>
          <ul className="mt-5 space-y-3" data-id="element-200" data-mp="1dlm2oze0oqdq">
            {bonuses.map(bono => <li key={bono.title} className="flex items-start justify-between gap-3 text-sm text-ink" data-id="element-201" data-mp="1iex9x1mqr966">
                <span className="flex items-start gap-2" data-id="element-202" data-mp="kwnf3mr4kw11">
                  <GiftIcon size={15} className="mt-0.5 flex-shrink-0 text-gold" data-id="element-203" data-mp="pw9sbw6yec9u" />
                  {bono.title}
                </span>
                <span className="flex-shrink-0 font-semibold text-ink-muted line-through" data-id="element-204" data-mp="1o8m5c1h2s4js">
                  {bono.value}
                </span>
              </li>)}
          </ul>
          <div className="mt-auto pt-5 text-center" data-id="element-205" data-mp="1y09tntic55h1">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-ink-muted" data-id="element-206" data-mp="1a9mhux5atvp7">
              Valor total de los bonos {BONUS_VALUE}
            </p>
            <p className="mt-1 font-display text-3xl font-bold uppercase text-cta" data-id="element-207" data-mp="15bunlwh6lxhu">
              Hoy: $0
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.1} data-id="element-208" data-mp="1eapw5f7p7job">
        <p className="mt-8 text-sm font-bold uppercase tracking-[0.18em] text-gold" data-id="element-209" data-mp="1eag7buye3ik7">
          Los 5 bonos van gratis con tu compra
        </p>
      </Reveal>
    </section>;
}